<!-- ========================= scroll-top ========================= -->
<a href="#" class="scroll-top btn-hover" [ngStyle]="getStyle()">
  <i class="lni lni-chevron-up"></i>
</a>
